import React from 'react';
import { SharedEffects } from './SharedEffects';

export function RibbonOverlay() {
  return (
    <div className="auth-overlay">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        viewBox="0 0 1440 900"
      >
        <defs>
          <filter id="ribbon-glow">
            <feGaussianBlur stdDeviation="6" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <linearGradient id="ribbon-grad-1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#4285F4" stopOpacity="0" />
            <stop offset="20%" stopColor="#4285F4" stopOpacity="0.25" />
            <stop offset="50%" stopColor="#4285F4" stopOpacity="0.4" />
            <stop offset="80%" stopColor="#4285F4" stopOpacity="0.25" />
            <stop offset="100%" stopColor="#4285F4" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="ribbon-grad-2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#4285F4" stopOpacity="0" />
            <stop offset="15%" stopColor="#4285F4" stopOpacity="0.15" />
            <stop offset="45%" stopColor="#4285F4" stopOpacity="0.3" />
            <stop offset="75%" stopColor="#4285F4" stopOpacity="0.15" />
            <stop offset="100%" stopColor="#4285F4" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="ribbon-grad-3" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#4285F4" stopOpacity="0" />
            <stop offset="25%" stopColor="#4285F4" stopOpacity="0.12" />
            <stop offset="55%" stopColor="#4285F4" stopOpacity="0.2" />
            <stop offset="85%" stopColor="#4285F4" stopOpacity="0.12" />
            <stop offset="100%" stopColor="#4285F4" stopOpacity="0" />
          </linearGradient>
        </defs>

        <path d="M-40,180 C120,120 240,320 420,240 C600,160 680,380 860,300 C1040,220 1120,400 1300,340 C1480,280 1520,160 1540,200" fill="none" stroke="url(#ribbon-grad-1)" strokeWidth="2" className="ribbon-1" filter="url(#ribbon-glow)" />
        <path d="M-40,180 C120,120 240,320 420,240 C600,160 680,380 860,300 C1040,220 1120,400 1300,340 C1480,280 1520,160 1540,200" fill="none" stroke="#4285F4" strokeWidth="0.8" className="ribbon-1-core" opacity="0.5" />
        <path d="M-20,380 C160,440 280,200 460,320 C640,440 760,180 940,280 C1120,380 1240,160 1420,260 C1500,310 1540,400 1560,360" fill="none" stroke="url(#ribbon-grad-2)" strokeWidth="1.8" className="ribbon-2" filter="url(#ribbon-glow)" />
        <path d="M-20,380 C160,440 280,200 460,320 C640,440 760,180 940,280 C1120,380 1240,160 1420,260 C1500,310 1540,400 1560,360" fill="none" stroke="#4285F4" strokeWidth="0.6" className="ribbon-2-core" opacity="0.35" />
        <path d="M-60,600 C140,540 300,700 480,620 C660,540 780,720 960,660 C1140,600 1260,740 1440,680 C1520,650 1560,580 1580,620" fill="none" stroke="url(#ribbon-grad-3)" strokeWidth="1.4" className="ribbon-3" filter="url(#ribbon-glow)" />
        <path d="M-60,600 C140,540 300,700 480,620 C660,540 780,720 960,660 C1140,600 1260,740 1440,680 C1520,650 1560,580 1580,620" fill="none" stroke="#4285F4" strokeWidth="0.5" className="ribbon-3-core" opacity="0.25" />

        <circle r="3" fill="#4285F4" opacity="0.7" filter="url(#ribbon-glow)">
          <animateMotion dur="6s" repeatCount="indefinite" path="M-40,180 C120,120 240,320 420,240 C600,160 680,380 860,300 C1040,220 1120,400 1300,340 C1480,280 1520,160 1540,200" />
          <animate attributeName="opacity" values="0;0.8;0.8;0" dur="6s" repeatCount="indefinite" />
        </circle>
        <circle r="2" fill="#4285F4" opacity="0.5" filter="url(#ribbon-glow)">
          <animateMotion dur="7s" repeatCount="indefinite" path="M-20,380 C160,440 280,200 460,320 C640,440 760,180 940,280 C1120,380 1240,160 1420,260 C1500,310 1540,400 1560,360" />
          <animate attributeName="opacity" values="0;0.6;0.6;0" dur="7s" repeatCount="indefinite" />
        </circle>
        <circle r="2" fill="#4285F4" opacity="0.4">
          <animateMotion dur="8.5s" repeatCount="indefinite" path="M-60,600 C140,540 300,700 480,620 C660,540 780,720 960,660 C1140,600 1260,740 1440,680 C1520,650 1560,580 1580,620" />
          <animate attributeName="opacity" values="0;0.5;0.5;0" dur="8.5s" repeatCount="indefinite" />
        </circle>
        <circle r="2" fill="#ffffff" opacity="0.4">
          <animateMotion dur="8s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" path="M-40,180 C120,120 240,320 420,240 C600,160 680,380 860,300 C1040,220 1120,400 1300,340 C1480,280 1520,160 1540,200" />
          <animate attributeName="opacity" values="0;0.3;0.3;0" dur="8s" repeatCount="indefinite" />
        </circle>
        <circle r="1.5" fill="#ffffff" opacity="0.3">
          <animateMotion dur="9s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" path="M-20,380 C160,440 280,200 460,320 C640,440 760,180 940,280 C1120,380 1240,160 1420,260 C1500,310 1540,400 1560,360" />
          <animate attributeName="opacity" values="0;0.25;0.25;0" dur="9s" repeatCount="indefinite" />
        </circle>
      </svg>

      <SharedEffects />
    </div>
  );
}
